import script from "./best-demat-account-for-beginners-in-india.vue?vue&type=script&setup=true&lang=js"
export * from "./best-demat-account-for-beginners-in-india.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__